import moment from "moment";
import pinyin from "pinyin";

let utility = {};

// 防抖
utility.debounce = (func, wait, immediate)=>{
	let timeout, args, context, timestamp, result

	const later = function(){
		// 据上一次触发时间间隔
		const last = +new Date() - timestamp

		// 上次被包装函数被调用时间间隔last小于设定时间间隔wait
		if (last < wait && last > 0){
			timeout = setTimeout(later, wait - last)
		}else{
			timeout = null
			// 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
			if(!immediate){
				result = func.apply(context, args)
				if(!timeout){
					context = args = null
				}
			}
		}
	}
	return function(...args){
		context = this
		timestamp = +new Date()
		const callNow = immediate && !timeout
		// 如果延时不存在，重新设定延时
		if(!timeout){
			timeout = setTimeout(later, wait)
		}
		if(callNow){
			result = func.apply(context, args)
			context = args = null
		}

		return result
	}
}

// 获取系统
utility.getPlatform = function(){
	let type = 'pc'
	let u = navigator.userAgent, app = navigator.appVersion;
	let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
	let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
	if (isAndroid) {
	   type = 'android';
	}else if (isIOS) {
	type = 'ios';
	}
	return type;
}

// 复制到剪贴板 执行成功后 调用callback
utility.copyToClip = function(content, callback) {
	var aux = document.createElement("textarea"); 
	aux.innerHTML = content; 
	document.body.appendChild(aux); 
	aux.select();
	document.execCommand("copy"); 
	document.body.removeChild(aux);
	if(callback) {
		callback();
	}
}

// 随机数
utility.random = function(lower, upper){
	return Math.floor(Math.random() * (upper - lower+1)) + lower;
}
utility.randomStr = function(n){
    let arr = ["的","一","是","在","不","了","有","和","人","这","中","大","为","上","个","国","我","以","要","他","时","来","用","们","生","到","作","地","于","出","就","分","对","成","会","可","主","发","年","动","同","工","也","能","下","过","子","说","产","种","面","而","方","后","多","定","行","学","法","所","民","得","经","十","三","之","进","着","等","部","度","家","电","力","里","如","水","化","高","自","二","理","起","小","物","现","实","加","量","都","两","体","制","机","当","使","点","从","业","本","去","把","性","好","应","开","它","合","还","因","由","其","些","然","前","外","天","政","四","日","那","社","义","事","平","形","相","全","表","间","样","与","关","各","重","新","线","内","数","正","心","反","你","明","看","原","又","么","利","比","或","但","质","气","第","向","道","命","此","变","条","只","没","结","解","问","意","建","月","公","无","系","军","很","情","者","最","立","代","想","已","通","并","提","直","题","党","程","展","五","果","料","象","员","革","位","入","常","文","总","次","品","式","活","设","及","管","特","件","长","求","老","头","基","资","边","流","路","级","少","图","山","统","接","知","较","将","组","见","计","别","她","手","角","期","根","论","运","农","指","几","九","区","强","放","决","西","被","干","做","必","战","先","回","则","任","取","据","处","队","南","给","色","光","门","即","保","治","北","造","百","规","热","领","七","海","口","东","导","器","压","志","世","金","增","争","济","阶","油","思","术","极","交","受","联","什","认","六","共","权","收","证","改","清","己","美","再","采","转","更","单","风","切","打","白","教","速","花","带","安","场","身","车","例","真","务","具","万","每","目","至","达","走","积","示","议","声","报","斗","完","类","八","离","华","名","确","才","科","张","信","马","节","话","米","整","空","元","况","今","集","温","传","土","许","步","群","广","石","记","需","段","研","界","拉","林","律","叫","且","究","观","越","织","装","影","算","低","持","音","众","书","布","复","容","儿","须","际","商","非","验","连","断","深","难","近","矿","千","周","委","素","技","备","半","办","青","省","列","习","响","约","支","般","史","感","劳","便","团","往","酸","历","市","克","何","除","消","构","府","称","太","准","精","值","号","率","族","维","划","选","标","写","存","候","毛","亲","快","效","斯","院","查","江","型","眼","王","按","格","养","易","置","派","层","片","始","却","专","状","育","厂","京","识","适","属","圆","包","火","住","调","满","县","局","照","参","红","细","引","听","该","冯","价","严","龙","飞"]
    let a = [];//保存所有字符
    let s = '';//最终输出字符
    arr.forEach((item)=>{
        a.push(...item)
    })
    for(let i=1;i<n;i++){
        let m = Math.floor(Math.random()*(a.length));//生成随机数
        s += a[m] 
    }
    return s;
}

// 动态计算表格高度
utility.calcTableHeight = function(vm){
	vm.tableWrapperHeight = 0;
	vm.$nextTick(()=>{
		if(vm.$refs.tableWrapper){
			vm.tableWrapperHeight = vm.$refs.tableWrapper.offsetHeight;
		}
	})
}

// 获取拼音首字母
utility.firstLetter = function(text){
	return pinyin(text,{
		segment:false,
		heteronym:false,
		style:pinyin.STYLE_FIRST_LETTER,
	}).join("");
}

// 获取全拼
utility.allLetter = function(text){
	return pinyin(text,{
		segment:false,
		heteronym:false,
		style:pinyin.STYLE_NORMAL,
	}).join("");
}

// 滚动主屏
utility.scrollTo = function(dom,direction,msec){
	let left = dom.scrollLeft;
	let top = dom.scrollTop;
	let width = dom.scrollWidth;
	let height = dom.scrollHeight;
	let scroll = [left,top];
	let index = 0;
	let path = 0;

	switch (direction) {
		case 'top':
			index = 1;
			path = -top;
			break;
		case 'bottom':
			index = 1;
			path =  height - top;
			break;
		case 'left':
			index = 0;
			path = -left;
			break;
		case 'right':
			index = 0;
			ath =  width - left;
			break;
	} 

	let time = 0;
	let speed = 1000/30;
	let pxSpeed = path/Math.ceil(msec/speed);
	let scrolling = function(){
		if(time <= msec){
			scroll[index] += pxSpeed;
			time += speed;
			dom.scrollTo(scroll[0],scroll[1]); 
			setTimeout(scrolling,speed);
		}
	}
	scrolling();
}

// 滚动到元素
utility.scrollToDom = function(parentDom,childDom,centerBool,direction,msec){
	if(direction=='horizontal'){
		let c = childDom.offsetLeft - parentDom.offsetLeft;
		let pnow = parentDom.scrollLeft;
		let ds = c;
		if(centerBool){
			let pc = parentDom.clientWidth;
			ds -= pc/2;
		}
		let scrollingFn = function(parentDom,pxSpeed){
			parentDom.scrollLeft += pxSpeed;
		};
	}else{
		let c = childDom.offsetTop - parentDom.offsetTop;
		let pnow = parentDom.scrollTop;
		let ds = c;
		if(centerBool){
			let pc = parentDom.clientHeight;
			ds -= pc/2;
		}
		let scrollingFn = function(parentDom,pxSpeed){
			parentDom.scrollTop += pxSpeed;
		};
	}

	let path = ds - pnow;
	let time = 0;
	let speed = 1000/30;
	let pxSpeed = path/Math.ceil(msec/speed);
	let scrolling = function(){
		if(time <= msec){
			time += speed;
			scrollingFn(parentDom,pxSpeed); 
			setTimeout(scrolling,speed);
		}
	}
	scrolling();
}


// 生成a标签，到后台页面下载
utility.download = function(name){
	let aTag = document.createElement('a');
	let content = '样本文件';
	let blob = new Blob([content]);
	aTag.download = name;
	aTag.href = URL.createObjectURL(blob);
	aTag.click();
	URL.revokeObjectURL(blob);
}

/*
	得到一个时间差的格式化时间
	@diff 时间差 必须
	@opt
		@maxUnit sec min hour day 默认为min
		@isCnSplit 是否为中文分割 默认不是
*/
utility.timeDiffFormat = function(diff,opt){
	let unit = [
		'sec',
		'min',
		'hour',
		'day',
	];
	let timeToSec = {
		sec:1,
		min:60,
		hour:60 * 60,
		day:24 * 60 * 60,
	};
	let cnSplit = {
		sec:"秒",
		min:"分",
		hour:"时",
		day:"天",
	};
	opt = opt || {
		maxUnit:'min',	
		isCnSplit:false,	
	}; 
	
	let maxUnit = opt.maxUnit || 'min';
	let index = unit.indexOf(maxUnit);
	let timeText = "";
	let timeLast = 0;
	for(let i=index; i>=0; i--){
		let time = parseInt(diff/timeToSec[unit[i]]);
		diff = diff%timeToSec[unit[i]]
		if((opt.isCnSplit && time!=0) || !opt.isCnSplit){
			if(!(i==index && time>10)){
				time = `0${time}`.substr(-2);
			}
			timeText += time;
			if(opt.isCnSplit){
				timeText += cnSplit[unit[i]];
			}else{
				timeText += ":";
			}
		}
		if(timeLast==0){
			timeLast = time;
		}
	}
	if(!opt.isCnSplit){
		timeText = timeText.substr(0,timeText.length-1)
	}

	return timeText;

}

export default utility;



// WEBPACK FOOTER //
// ./src/utils/utility.js